import { useState, useEffect } from "react";

const COOKIE_NAME = "is_app";

function getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name: string, value: string, days = 7) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
}

function detectIsApp(): boolean {
    if (typeof window === "undefined") return false;
    const params = new URLSearchParams(window.location.search);
    const fromParam = params.get("is_app") === "y";
    const fromCookie = getCookie(COOKIE_NAME) === "y";
    const result = fromParam || fromCookie;
    console.log(`[AUTH-WEB-0] detectIsApp: URL param=${fromParam}, cookie=${fromCookie} → isApp=${result}, URL=${window.location.href}`);
    return result;
}

export function useIsApp() {
    const [isApp, setIsApp] = useState(detectIsApp);
    const [appVersion, setAppVersion] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const isAppParam = params.get("is_app");
        const appVersionParam = params.get("ver");

        if (isAppParam === "y") {
            setCookie(COOKIE_NAME, "y", 7);
            setIsApp(true);
            console.log("[AUTH-WEB-0] useIsApp useEffect: is_app=y → setIsApp(true)");
        } else {
            const cookieVal = getCookie(COOKIE_NAME);
            setIsApp(cookieVal === "y");
            console.log(`[AUTH-WEB-0] useIsApp useEffect: cookie=${cookieVal} → setIsApp(${cookieVal === "y"})`);
        }

        if (appVersionParam) {
            setAppVersion(appVersionParam);
        }
    }, [window.location.search]);

    return { isApp, appVersion };
}
